function GamesProject() {
    return (<div>
        My team created a VR racing game where players moved using spider-man swinging to move through a city. The cities were generated entirely from open source data, so players could pick a start location on the map of the world and have the surrounding area generated and a race course made. This was one my favourite modules and my first time working in a fully agile team.
    </div>);
}

export default GamesProject;